<div class="flex items-center justify-center dialog-header">
    <div *ngIf="communicationData?.first_name">
        WhatsApp to {{ communicationData?.first_name }} {{ communicationData?.last_name }}
    </div>
    <div *ngIf="!communicationData?.first_name">
        Send WhatsApp Message
    </div>

    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>
</div>

<div class="dialog-content">
    <!-- Lead Details Section -->
    <div class="p-4 pt-3 pb-3 rounded-lg mb-4" style="background-color: var(--surface-card); border: 1px solid var(--surface-border);">
        <div class="flex items-center justify-between mb-3">
            <h3 class="text-lg font-semibold" style="color: var(--text-color);">Lead Details</h3>
            <button 
                *ngIf="!isEditingDetails" 
                (click)="toggleEditDetails()" 
                class="text-blue-600 hover:text-blue-800 text-sm flex items-center gap-1">
                <i class="pi pi-pencil"></i>
                Edit Details
            </button>
            <div *ngIf="isEditingDetails" class="flex gap-2">
                <button 
                    (click)="saveEditedDetails()" 
                    class="text-green-600 hover:text-green-800 text-sm flex items-center gap-1">
                    <i class="pi pi-check"></i>
                    Save
                </button>
                <button 
                    (click)="toggleEditDetails()" 
                    class="text-red-600 hover:text-red-800 text-sm flex items-center gap-1">
                    <i class="pi pi-times"></i>
                    Cancel
                </button>
            </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <!-- Name Field -->
            <div>
                <label class="block text-sm font-medium mb-1" style="color: var(--text-color-secondary);">Name</label>
                <div *ngIf="!isEditingDetails" class="p-2 rounded border" style="background-color: var(--surface-ground); border-color: var(--surface-border); color: var(--text-color);">
                    {{ editableName || 'Not provided' }}
                </div>
                <input 
                    *ngIf="isEditingDetails"
                    type="text" 
                    pInputText 
                    [(ngModel)]="editableName" 
                    class="w-full"
                    placeholder="Enter name" />
            </div>

            <!-- Email Field -->
            <div>
                <label class="block text-sm font-medium mb-1" style="color: var(--text-color-secondary);">Email</label>
                <div *ngIf="!isEditingDetails" class="p-2 rounded border" style="background-color: var(--surface-ground); border-color: var(--surface-border); color: var(--text-color);">
                    {{ editableEmail || 'Not provided' }}
                </div>
                <input 
                    *ngIf="isEditingDetails"
                    type="email" 
                    pInputText 
                    [(ngModel)]="editableEmail" 
                    class="w-full"
                    placeholder="Enter email" />
            </div>

            <!-- Phone Field -->
            <div>
                <label class="block text-sm font-medium mb-1" style="color: var(--text-color-secondary);">Phone Number *</label>
                <div *ngIf="!isEditingDetails" class="p-2 rounded border flex items-center gap-2" style="background-color: var(--surface-ground); border-color: var(--surface-border); color: var(--text-color);">
                    <i class="pi pi-phone text-green-600"></i>
                    {{ formatPhoneNumber(editablePhone) || 'Not provided' }}
                </div>
                <div *ngIf="isEditingDetails" class="flex items-center gap-2">
                    <i class="pi pi-phone text-green-600"></i>
                    <input 
                        type="tel" 
                        pInputText 
                        [(ngModel)]="editablePhone" 
                        class="w-full"
                        placeholder="Enter phone number with country code (e.g., +1234567890)" />
                </div>
            </div>

            <!-- Additional Lead Info -->
            <!-- <div class="md:col-span-2" *ngIf="communicationData?.lead_type || communicationData?.source">
                <div class="flex gap-4 text-sm text-gray-600">
                    <span *ngIf="communicationData?.lead_type" class="flex items-center gap-1">
                        <i class="pi pi-tag"></i>
                        {{ communicationData.lead_type }}
                    </span>
                    <span *ngIf="communicationData?.source" class="flex items-center gap-1">
                        <i class="pi pi-globe"></i>
                        {{ communicationData.source }}
                    </span>
                </div>
            </div> -->
        </div>
    </div>

    <!-- Message Section -->
    <div>
        <div class="mb-2 font-medium flex items-center gap-2" style="color: var(--text-color);">
            <i class="pi pi-whatsapp text-green-600"></i>
            WhatsApp Message
        </div>
        <textarea 
            class="w-full min-h-[150px] p-3 rounded-md resize-vertical"
            style="border: 1px solid var(--surface-border); background-color: var(--surface-card); color: var(--text-color); box-shadow: none !important;" 
            [rows]="7"
            [(ngModel)]="whatsappMessage"
            placeholder="Type your WhatsApp message here...">
        </textarea>
        <div class="text-xs mt-1" style="color: var(--text-color-secondary);">
            Message will be opened in WhatsApp where you can review and send it.
        </div>
    </div>

    <!-- WhatsApp Options Info -->
    <div class="p-3 rounded-lg mt-4" style="background-color: var(--surface-hover); border: 1px solid var(--surface-border);">
        <div class="flex items-start gap-2">
            <i class="pi pi-info-circle text-blue-600 mt-1"></i>
            <div class="text-sm" style="color: var(--text-color);">
                <div class="font-medium mb-1">WhatsApp Options:</div>
                <ul class="text-xs space-y-1" style="color: var(--text-color-secondary);">
                    <li>• <strong>Web Version:</strong> Opens in browser (requires WhatsApp Web login)</li>
                    <li>• <strong>App Version:</strong> Opens WhatsApp app or asks to download</li>
                    <li>• <strong>Login Check:</strong> Opens WhatsApp Web to login first</li>
                </ul>
            </div>
        </div>
    </div>

    <!-- Action Buttons -->
    <div class="mt-6">
        <div class="flex justify-between items-center mb-3">
            <div class="text-sm flex items-center gap-2" style="color: var(--text-color-secondary);">
                <i class="pi pi-whatsapp text-green-600"></i>
                Choose how to send WhatsApp message
            </div>
            <p-button 
                label="Cancel" 
                icon="pi pi-times" 
                [outlined]="true"
                severity="secondary"
                size="small"
                (click)="handleCloseDialog()">
            </p-button>
        </div>
        
        <div class="flex flex-wrap gap-2">
            <p-button 
                label="Send via Web" 
                [loading]="loading" 
                [disabled]="loading || !editablePhone || !whatsappMessage.trim()" 
                icon="pi pi-globe" 
                severity="success"
                (click)="handleSendWhatsApp()">
            </p-button>
            
            <p-button 
                label="Send via App" 
                [disabled]="loading || !editablePhone || !whatsappMessage.trim()" 
                icon="pi pi-mobile" 
                severity="help"
                [outlined]="true"
                (click)="sendViaWaMe()">
            </p-button>
            
            <p-button 
                label="Login to Web" 
                icon="pi pi-sign-in" 
                severity="warn"
                [outlined]="true"
                (click)="checkWhatsAppLogin()">
            </p-button>
        </div>
    </div>
</div>
